<template>
  <div
    class="z-10 h-14 md:h-15 aha-presentation-editor-header"
    :class="{'in-demo-mode': isGuestUser}"
    v-if="presentation.id && renderPresentationDetail && !isPresentingPpt"
  >
    <!--z-10 for header box shadow to appear -->
    <EditorHeader @update-online-count="updatePresentationSessionOnlineCount">
      <template #extension>
        <PowerPointAddinButtonGroup />
      </template>
    </EditorHeader>
  </div>
</template>
<script>
import EditorHeaderWrapper from './EditorHeaderWrapper.vue'

import PowerPointAddinButtonGroup from '@/components-v2/presentation-editor/PowerPointAddinButtonGroup.vue'

export default {
  components: {
    PowerPointAddinButtonGroup,
  },
  extends: EditorHeaderWrapper,
}
</script>

<style lang="scss" scoped>
.aha-presentation-editor-header.in-demo-mode {
  @apply mt-10;
}
.aha-presentation-editor-header {
  z-index: 11;
}
</style>
